export default function($) {
  $(document).ready(function () {

    var windowWidth = $(window).width(), 
    headerHeight = $('header').height(), 
    footerHeight = $('footer').height(), 
    sumHeight = headerHeight + footerHeight + 4;

    $('.js-button-see-map').on('click', function() {
      $('.js-list').addClass('hidden');
      $('.js-result-wrapper').addClass('ratio');
      $('.js-map')
        .addClass('ratio-content')
        .css({
          'left': '0',
          'z-index': '30'
        });
    });
    $('.js-button-see-list').on('click', function() {
      $('.js-map')
        .removeClass('ratio-content')
        .css({
          'left': '100%',
          'z-index': '30'
        });
      $('.js-list').removeClass('hidden');
      $('.js-result-wrapper').removeClass('ratio');
    })
    
    if( windowWidth > 960 ) {
      $('.js-result-wrapper, .js-list').css('height', 'calc(100vh - ' + sumHeight + 'px)');
    } else {
      $('.js-result-wrapper, .js-list').css('height', 'auto');
    }
  
    $(window).resize(function() {
      if( $(window).width() > 960 ) {
        $('.js-result-wrapper, .js-list').css('height', 'calc(100vh - ' + sumHeight + 'px)');

        $('.js-map')
          .removeClass('ratio-content')
          .css('left', 'auto');
        $('.js-list').removeClass('hidden');
        $('.js-result-wrapper').removeClass('ratio');
      } else {
        $('.js-result-wrapper, .js-list').css('height', 'auto');
        $('.js-map').css('left', '100%');
      }
    });
  
  });
}